import { render, staticRenderFns } from "./ChartAvgStatsPerLevel.vue?vue&type=template&id=f3404da2&scoped=true"
import script from "./ChartAvgStatsPerLevel.js?vue&type=script&lang=js&external"
export * from "./ChartAvgStatsPerLevel.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3404da2",
  null
  
)

export default component.exports